export function bindMunicipalitySelect(form) {
  const prefectureSelect = form.querySelector('[data-prefecture-select]')
  const municipalitySelect = form.querySelector('[data-municipality-select]')
  if (!(prefectureSelect instanceof HTMLSelectElement) || !(municipalitySelect instanceof HTMLSelectElement)) {
    return
  }

  const optionsByPrefecture = parseMunicipalityOptions(form.dataset.municipalityOptionsByPrefecture || '{}')
  const initialMunicipalitySlug = municipalitySelect.value
  const placeholderLabel = municipalitySelect.options[0]?.textContent || '市区町村を選択'

  const updateMunicipalityOptions = (selectedSlug = '') => {
    const prefectureSlug = prefectureSelect.value
    const options = optionsByPrefecture[prefectureSlug] || []

    const fragment = document.createDocumentFragment()
    municipalitySelect.disabled = prefectureSlug === ''

    const placeholderOption = document.createElement('option')
    placeholderOption.value = ''
    placeholderOption.textContent = placeholderLabel
    placeholderOption.selected = selectedSlug === ''
    fragment.appendChild(placeholderOption)

    options.forEach((item) => {
      if (!Array.isArray(item.options)) {
        fragment.appendChild(buildMunicipalityOption(item, selectedSlug))
        return
      }
      if (item.options.length === 0) {
        return
      }

      const optionGroup = document.createElement('optgroup')
      optionGroup.label = typeof item.label === 'string' ? item.label : ''
      item.options.forEach((option) => {
        optionGroup.appendChild(buildMunicipalityOption(option, selectedSlug))
      })
      fragment.appendChild(optionGroup)
    })
    municipalitySelect.replaceChildren(fragment)
  }

  prefectureSelect.addEventListener('change', () => updateMunicipalityOptions(''))

  updateMunicipalityOptions(initialMunicipalitySlug)
}

function buildMunicipalityOption(item, selectedSlug) {
  const option = document.createElement('option')
  const count = Number.isInteger(item.count) ? item.count : null
  option.value = item.slug
  option.dataset.optionLabel = item.name
  if (count !== null) option.dataset.optionCount = String(count)
  option.textContent = count === null ? item.name : `${item.name}（${count}件）`
  option.selected = option.value === selectedSlug
  return option
}

function parseMunicipalityOptions(rawJson) {
  try {
    const parsed = JSON.parse(rawJson)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch (_error) {
    return {}
  }
}
